import React from 'react';
import FileBase64 from '../util/Input64';
import { Input, Icon, Tooltip, Button, Select, Breadcrumb, Popover, AutoComplete, Popconfirm, message } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import SERVER_URL from '../Global';

const { Option } = Select;

export class ModifyCat extends React.Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);

        this.state = {
            user: this.props.token,
            catId: params.catId,
            catSaved: true,
            catName: null,
            category: [],
            categories:[],
            parentId: null,
            status: 1,
            companies: [],  
            parentName: '',
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.saveCat = this.saveCat.bind(this);
        this.handleParent = this.handleParent.bind(this);
        this.catNameWritten = this.catNameWritten.bind(this);
        document.title = "Polar - Categories"


        //tutte categorie
        fetch(
            `${SERVER_URL + 'api/companycategory/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": '',
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 80,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    let categories = []
                    res.data.map(cat => {
                        if (cat.companyCategoryParent == null && cat.catId != this.state.catId) {
                            categories.push({ id: cat.catId, name: cat.name })
                        }
                    })
                    this.setState({ categories: categories });
                } else {
                    this.setState({ categories: [] });
                }

            })
    }

    componentDidMount() {

        //questa categoria
        fetch(
            `${SERVER_URL + 'api/companycategory/' + this.state.catId + '?lang=en'}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    if (res.data.companyCategoryParent != null) {
                        this.setState({ parentName: res.data.companyCategoryParent.name })
                    } else { this.setState({ parentName: null })}
                    this.setState({ category: res.data, parentId: res.data.companyCategoryParentCatId, catName: res.data.name, status: res.data.status })
                    //compagnie con questa categoria
                    fetch(
                        `${SERVER_URL + 'api/company/list?lang=en'}`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${this.state.user}`,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                "companyCategoryName": res.data.name,
                                "includeSoftDeleted": true,
                                "page": 1,
                                "PageSize": 5,
                                "ordering": {
                                    "orderPropertyName": "CompanyName",
                                    "order": 0
                                }
                            })
                        }
                    ).then(response => response.json())
                        .then(res => {
                            if (res.data != null) {
                                this.setState({ companies: res.data });
                            }
                        })

                } else {
                    "Category hasn't been found"
                }
            }
        )
    }

    handleNameChange(event) {
        this.setState({ catName: event.target.value, catSaved: false });

        if (event.target.value.length === 0) {
            this.setState({ catName: null })
        }
    }

    handleParent(value) {
        const index = this.state.categories.findIndex(cat => cat.id == value)
        this.setState({ parentId: value, catSaved: false, parentName: this.state.categories[index].name })
    }

    catNameWritten(value) {
        if (value.length != 0) {
            this.setState({ parentName: value, catSaved: false });
        } else {
            this.setState({ parentName: value, parentId: '', catSaved: false });
        }
    } 

    saveCat() {
        fetch(`${SERVER_URL + 'api/CompanyCategory'}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`,
            },
            body: JSON.stringify({
                'name': this.state.catName,
                'catId': this.state.catId,
                'CompanyCategoryParentCatId': this.state.parentId,
                "Status": this.state.status,
            })
        }).then(response => response.json())
            .then(res => {
                if (res.ok) {
                    this.setState({ catSaved: true })
                } else {
                    message.warning(res.errorMessage)
                }
            })
    }

    deleteCat(catId) {
        fetch(`${SERVER_URL + 'api/companycategory/hard/' + catId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
        }).then(response => response.json())
            .then(res => {
                if (res.ok) {
                    window.location = "/category/index";
                }
            });
    }

    goBack() {
        return window.open("/category/index", '_self');
    }

    render() {

        let name = this.state.catName != null ? this.state.catName : ''

        let mandatoryName = this.state.catName != null ? <Icon style={{ marginTop: '12px', marginLeft: '15px' }} type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon style={{ marginTop: '12px', marginLeft: '15px' }} type="exclamation-circle" /></Tooltip>

        let catSave = this.state.catSaved ? <Popover content="The Category is already saved"><Button disabled className="saveButtonHrWizard" icon="save">Save Category</Button></Popover>
            : this.state.catName != null ? <Button onClick={this.saveCat} className="saveButtonHrWizard" icon="save">Save Category</Button>
            : <Popover content="A name is needed in order to save the Category"><Button disabled className="saveButtonHrWizard" icon="save">Save Category</Button></Popover>

        let catDelete = this.state.companies.length == 0 ? 
            <Popconfirm title="Are you sure?" okText="Yes" cancelText="No" onConfirm={() => this.deleteCat(this.state.catId)} >
                <Button style={{ marginLeft: '5px' }} className="saveButtonHrWizard" icon="delete"> Delete Category</Button>
            </Popconfirm>
            : <Popover content="Only Empty Categories can be Deleted, this category has one or more Companies associated"> <Button style={{ marginLeft: '5px' }} disabled className="saveButtonHrWizard" icon="delete"> Delete Category</Button></Popover>

        let listacat = this.state.categories.map(cat =>
            <Option key={cat.id}>{cat.name}</Option>
        )        

        let listaComp = this.state.companies.length == 0 ?
            <h4>There are no Companies with this Category</h4>
            :
            <div>
                <h4 style={{ marginTop:'50px' }}>First five Companies with this category:</h4>
                <ul>
                    {this.state.companies.map((el, i) => {
                        if (el.isDeleted) {
                            return (
                                <li key={el.companyId}><b>{el.name} (Deleted)</b></li>
                            )
                        } else {
                            return (
                                <li key={el.companyId}><Link to={"/edit?id=" + el.companyId} >{el.name}</Link></li>
                            )
                        }
                    })}
                </ul>
            </div>
       
        return (
            <Container fluid={true}>
                <Row className="justify-content-center">
                    <Col style={{ height: '100%' }} sm="12">
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>Edit Categories</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Row style={{ width: '100%' }}>
                        <Col style={{ minHeight: '50vh' }} sm='12'>
                            <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                                <div className="wizardBackground" style={{ height: 'inherit' }}>
                                    <div>
                                        <div className="modifyHrBox createCat" style={{ width: '100%' }}>
                                            <h2 style={{ fontSize:'22px', marginBottom: '20px' }}>{name}</h2>
                                            <div className={"modifyHr" + this.state.catSaved} style={{ width: '100%' }}>
                                                <div style={{ width: '100%', display: 'inline-flex' }}>
                                                    <div style={{ width: '48%' }}>
                                                        <div style={{ width: '100%', display: 'inline-flex' }}>
                                                            <Tooltip placement="topLeft" title="If the new Category has a Parent Category, select it here. Child Categories cannot be Parent Cateogories">
                                                                <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Parent Category:</h4>
                                                            </Tooltip>
                                                        </div>
                                                        <div style={{ width: '100%', display: 'inline-flex' }}>
                                                            <AutoComplete
                                                                dataSource={listacat}
                                                                placeholder="Parent Category"
                                                                style={{ width: '100%' }}
                                                                onSelect={this.handleParent}
                                                                onSearch={this.catNameWritten}
                                                                value={this.state.parentName}
                                                                filterOption={(inputValue, option) =>
                                                                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ width: '48%', marginLeft: '4%' }}>
                                                        <div style={{ width: '100%', display: 'inline-flex' }}>
                                                            <Tooltip placement="topLeft" title="Insert here New Category name">
                                                                <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Category:</h4>
                                                            </Tooltip>
                                                        </div>
                                                        <div style={{ width: '100%', display: 'inline-flex' }}>
                                                            <Input autoComplete="new-password" value={name} style={{ width: '100%' }} className="contactText hrNameValidation" allowClear={true} placeholder="Category name" onChange={this.handleNameChange} />
                                                            {mandatoryName}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="catButtons">
                                                    {catSave}{catDelete}
                                                </div>
                                            </div>                                            
                                            {listaComp}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Container>

        )
    }
}

export default ModifyCat;


// WEBPACK FOOTER //
// ./src/Modify/ModifyCat.js